import { appConfig, headerConfig, refineHeader } from "../../config";

export const emailService = {
    add_smtp,
    get_smtp_setting_details,
    delete_smtp,
    get_email_tempelate_list,
    get_email_tempelate_details,
    update_email_tempelate,
    testTemplate,
    testTemplateAbandon
};

function add_smtp(postData) {
    refineHeader();
    const requestOptions = {
        method: "POST",
        headers: headerConfig.headerDatas,
        mode: "cors",
        IDBTransaction,
        body: JSON.stringify(postData)
    };

    return fetch(`${appConfig.api.url}smtp/smtp-settings`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function testTemplate(postData) {
    refineHeader();
    const requestOptions = {
        method: "POST",
        headers: headerConfig.headerDatas,
        mode: "cors",
        IDBTransaction,
        body: JSON.stringify(postData)
    };

    return fetch(`${appConfig.api.url}email-template/test-template`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function testTemplateAbandon(postData) {
    refineHeader();
    const requestOptions = {
        method: "POST",
        headers: headerConfig.headerDatas,
        mode: "cors",
        IDBTransaction,
        body: JSON.stringify(postData)
    };

    return fetch(`${appConfig.api.url}email-template/test-template-abandon`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}


function get_email_tempelate_list(postData) {
    refineHeader();
    const requestOptions = {
        method: "POST",
        headers: headerConfig.headerDatas,
        mode: "cors",
        IDBTransaction,
        body: JSON.stringify(postData)
    };

    return fetch(`${appConfig.api.url}email-template/list`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function get_smtp_setting_details() {
    refineHeader();
    const requestOptions = {
        method: "POST",
        headers: headerConfig.headerDatas,
        mode: "cors"
    };

    return fetch(`${appConfig.api.url}smtp/detail`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function delete_smtp() {
    refineHeader();
    const requestOptions = {
        method: "DELETE",
        headers: headerConfig.headerDatas,
        mode: "cors",
        // body: JSON.stringify()
    };

    return fetch(`${appConfig.api.url}smtp/delete`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function get_email_tempelate_details(templateID) {
    refineHeader();
    const requestOptions = {
        method: "GET",
        headers: headerConfig.headerDatas,
        mode: "cors"
    };

    return fetch(
        `${appConfig.api.url}email-template/detail/${templateID}`,
        requestOptions
    )
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function update_email_tempelate(postData) {
    refineHeader();
    const requestOptions = {
        method: "PUT",
        headers: headerConfig.headerDatas,
        mode: "cors",
        IDBTransaction,
        body: JSON.stringify(postData)
    };

    return fetch(`${appConfig.api.url}email-template/edit`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}



// WEBPACK FOOTER //
// ./src/app/services/API/emailService.js